import { ContentView } from '../../../api/client'

type Props = { content: ContentView }

/**
 * The "Replying to" line on a reply's card. Only X and Facebook tell Arwen who a
 * reply answers, so on every other platform this renders nothing; ReplyBadge in
 * the metadata row is what flags a reply and opens the conversation drawer.
 */
export default function ContentReplyTo(props: Props) {
    const { content } = props

    if (!content.isReply || !content.inReplyToUsername) {
        return null
    }

    // Facebook gives the parent author's display name ("Lisa Lee"), not a handle, so an @ in
    // front of it would read wrongly.
    const handlePrefix = content.socialMediaServiceName.toLowerCase() === 'facebook' ? '' : '@'

    return (
        <div className="text-ink-500">
            Replying to{' '}
            <span className="text-arwen-700">
                {handlePrefix}
                {content.inReplyToUsername}
            </span>
        </div>
    )
}
